import React, { useEffect, useContext, useState, useCallback, useRef } from 'react';
import LoadingBar from '../../components/global/loadingBar';
import Filter from '../../components/filter';
import { ReactComponent as SearchIcon } from '../../../assets/svg/search.svg';
import { ReactComponent as DoubleArrowIcon } from '../../../assets/svg/up-arrow.svg';
import LabelCard from './LabelCard';
import { Space } from 'antd';
import DeliverablesTable from './DeliverablesTable';
import Context from '../../../context/context';
import { useSearchParams } from 'react-router-dom';
import Pagination from './CustomPagination';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import DeliverablesCreateModal from '../../components/modals/Deliverables/DeliverablesCreateModal';
import CreateDeliverSlider from '../../components/modals/Deliverables/CreateDeliverSlider';
import { ReactComponent as ArrowIcon } from '../../../assets/svg/deliverables/single_up_arrow.svg';
import { ReactComponent as EqualIcon } from '../../../assets/svg/deliverables/equalto.svg';
import { ReactComponent as DownIcon } from '../../../assets/svg/deliverables/single_down_arrow.svg';
import _ from 'lodash';

const Deliverables = (props) => {
	const urlParams = useParams();
	const [load, setLoad] = useState(true);
	const [statusload, setStatusLoad] = useState(true);
	const [searchParams, setSearchParams] = useSearchParams();
	const params = Object.fromEntries(searchParams);

	const [filters, setFilters] = useState(() => {
		let val = [];
		if (params?.workspaceFilter) {
			if (params.workspaceFilter.length == 1) {
				val = [params.workspaceFilter];
			} else {
				val = params.workspaceFilter.split(',');
			}
		}

		return {
			workspaceFilter: val,
			AssignedtoFilter: params?.AssignedtoFilter || '',
			page: +params?.page || 1,
			limit: +params?.limit || 10,
			StatusFilter: params?.StatusFilter || '',
			projectsFilter: params?.projectsFilter || '',
			search: params?.search || '',
		};
	});
	const timeout = useRef();
	const [data, setData] = useState({
		dataSource: [],
		totalDocs: 0,
		vendorUsers: [],
		associatedTenant: [],
		associatedTenantsId: [],
		associatedTenantsName: [],
		vendorsId: [],
		projectsLists: [],
		projects: [],
		projectId: [],
		statusFiltercount: {},
		all: 0,
		overdue: 0,
		unassigned: 0,
		unscheduled: 0,
		record: null,
		workspaceLabelValue: null,
		projectLabelValue: null,
		slider: false,
		search: '',
	});

	let {
		deliverableInfo: {
			getAlldeliverablesData,
			deliverablesData,
			getAllEventList,
			associatedTenants,
			getAllfiltersCount,
			filtersCount,
			isPageLoading,
			updatePageLoading,
			updateModalState,
			UpdateDeliverableState,
			updateCreateDeliverableState,
			isStateLoading,
			getAllWorkspaceProjects,
			workspaceProjectList,
			updateRecord,
		},
	} = useContext(Context);

	useEffect(() => {
		const params = Object.fromEntries(searchParams);
		let filtersObj = {};

		for (const key in params) {
			if (key === 'workspaceFilter') {
				let info = params[key].split(',');

				filtersObj[key] = info;
			} else {
				filtersObj[key] = params[key];
			}
		}

		setSearchParams((prev) => {
			return {
				...filtersObj,
			};
		});

		updatePageLoading({ type: 'isPageLoading', data: true });
		updatePageLoading({ type: 'isStateLoading', data: true });
		getAllEventList(urlParams.vendorID);
	}, []);

	useEffect(() => {
		createParams();
		setLoad(true);
		updatePageLoading({ type: 'isPageLoading', data: true });
		getAlldeliverablesData(filters, urlParams.vendorID);
	}, [filters]);

	useEffect(() => {
		if (filters.workspaceFilter?.length && data?.associatedTenantsId?.length) {
			let workspaceName = filters?.workspaceFilter?.map((e) => {
				let workspaceIndex = data.associatedTenantsId?.indexOf(e);
				return data.associatedTenantsName?.[workspaceIndex]?.name;
			});

			let wjson = {
				workspaceIds: workspaceName,
				filters: {
					limit: 1000,
					page: 1,
				},
			};

			getAllWorkspaceProjects(wjson, urlParams.vendorID);
		}
	}, [filters.workspaceFilter, data.associatedTenantsId, data.associatedTenantsName]);

	useEffect(() => {
		if (UpdateDeliverableState?.status === 'success') {
			getAlldeliverablesData(filters, urlParams.vendorID);
			getAllfiltersCount(filters, urlParams.vendorID);
			updateCreateDeliverableState({ type: UpdateDeliverableState, data: null });
			setData((prev) => {
				return { ...prev, slider: false };
			});
			updateRecord(null);
			updateModalState('createModal', false);
		} else if (UpdateDeliverableState?.status === 'caneled') {
			setData((prev) => {
				return { ...prev, slider: false };
			});
			updateRecord(null);
			updateModalState('createModal', false);
		} else if (UpdateDeliverableState?.status === 'failed') {
			setData((prev) => {
				return { ...prev, slider: false };
			});
			updateRecord(null);
			updateModalState('createModal', false);
		}
	}, [UpdateDeliverableState]);

	useEffect(() => {
		setStatusLoad(true);
		updatePageLoading({ type: 'isStateLoading', data: true });
		getAllfiltersCount(filters, urlParams.vendorID);
	}, [filters.workspaceFilter]);

	useEffect(() => {
		setData((prev) => {
			return {
				...prev,
				totalDocs: deliverablesData?.vendorDeliverablesList?.totalDocs || 0,
				dataSource: deliverablesData?.vendorDeliverablesList?.data || [],
			};
		});
	}, [deliverablesData]);

	//assosciated tennants
	useEffect(() => {
		let vendorUsers = associatedTenants?.vendorUsers || [];
		let associatedTenant = associatedTenants?.vendorInfo?.associatedTenants || [];
		let associatedTenantsId, associatedTenantsName, vendorsId;
		if (associatedTenant?.length) {
			associatedTenantsId = associatedTenant.map((ele) => ele._id);
			associatedTenantsName = associatedTenant.map((ele) => {
				return {
					key: ele._id,
					name: ele.workspaceId,
				};
			});
		}

		if (vendorUsers?.length) {
			vendorsId = vendorUsers.map((ele) => ele.id);
			vendorUsers = vendorUsers.map((ele) => {
				return {
					key: ele.id,
					name: ele.firstName + ' ' + ele.lastName,
				};
			});
		}
		setData((prev) => {
			return {
				...prev,
				vendorUsers,
				associatedTenant,
				associatedTenantsId,
				associatedTenantsName,
				vendorsId,
			};
		});
	}, [associatedTenants]);

	useEffect(() => {
		let projectsLists = workspaceProjectList?.vendorsProjects?.data; //projectlist
		let projects, projectId;
		if (projectsLists?.length) {
			projectId = projectsLists.map((ele) => ele.id);
			projects = projectsLists.map((ele) => {
				return {
					key: ele.id,
					name: ele.title,
				};
			});
		}
		setData((prev) => {
			return {
				...prev,
				projectsLists,
				projectId,
				projects,
			};
		});
	}, [workspaceProjectList]);

	useEffect(() => {
		let statusFiltercount = {
			todo: 0,
			inProgress: 0,
			inReview: 0,
			done: 0,
			onHold: 0,
		};
		if (filtersCount) {
			var { all, overdue, unassigned, unscheduled } = filtersCount?.deliverableDefaultFilters;
			let statusFilterarray = filtersCount?.deliverableDefaultFilters?.statusFilters;
			for (let i = 0; i < statusFilterarray?.length; i++) {
				const ele = statusFilterarray[i];
				statusFiltercount[ele.status] = ele.count;
			}
		}

		setData((prev) => {
			return {
				...prev,
				all,
				overdue,
				unassigned,
				unscheduled,
				statusFiltercount,
			};
		});
	}, [filtersCount]);

	const sayChange = (record) => {
		const tenantId = record.tenantId;
		const workspaceValueIndex = data.associatedTenantsId.indexOf(tenantId);
		let workspaceLabelValue = data.associatedTenantsName[workspaceValueIndex];

		workspaceLabelValue = { label: workspaceLabelValue.name, value: tenantId };

		const projectLabelValue = { label: record.projectTitle, value: record.projectId };
		setData((prev) => {
			return { ...prev, record, workspaceLabelValue, projectLabelValue, slider: true };
		});
		updateRecord(record);
		updateCreateDeliverableState({ type: UpdateDeliverableState, data: null });
		updateModalState('createModal', true);
	};

	const columns = [
		{
			title: 'ID',
			dataIndex: 'id',
			key: 'ID',
			renderis: (record) => {
				const index = data.associatedTenantsId?.indexOf(record.tenantId);

				let str = '';
				if (index !== -1) {
					str = data.associatedTenant[index]?.workspaceKey + '-' + record.slNo;
				}

				return <span>{str}</span>;
			},
		},
		{
			title: 'DELIVERABLE',
			dataIndex: 'name',
			key: 'DELIVERABLE',
			renderis: (record) => {
				return (
					<span
						style={{
							display: 'flex',
							flexDirection: 'column',
							textTransform: 'capitalize',
						}}
					>
						<span style={{ marginBottom: '6px' }}>{record.projectTitle || ''}</span>
						<span style={{ color: '#B0B0B0' }}>{record.title}</span>
					</span>
				);
			},
		},
		{
			title: 'STATUS',
			dataIndex: 'status',
			key: 'STATUS',
			renderis: (record) => {
				let col;

				let status = record.status.toUpperCase();
				let state = status;
				if (status !== 'DONE') {
					status = status.split('');
					status.splice(2, 0, ' ');
					status.join('');
					status = status.join('');
				}
				if (state === 'TODO') {
					col = '#9F4DB7';
				} else if (state === 'INPROGRESS') {
					col = '#5383EC';
				} else if (state === 'INREVIEW') {
					col = '#8EE2C7';
				} else if (state === 'DONE') {
					col = '#479A5F';
				} else if (state === 'ONHOLD') {
					col = 'rgb(255, 87, 51)';
				}

				return (
					<span
						style={{ display: 'flex', alignItems: 'center' }}
						className="delivarableStatusCheck"
					>
						<b style={{ backgroundColor: col }}></b>
						<span>{status}</span>
					</span>
				);
			},
		},
		{
			title: 'ASSIGNED TO',
			dataIndex: 'assignedTo',
			key: 'ASSIGNED',
			renderis: (record) => {
				const index = data.vendorsId?.indexOf(record.assignedTo);
				return (
					<span style={{ textTransform: 'capitalize' }}>
						{_.has(record.assignedTo, 'name') ? record.assignedTo.name : ''}
					</span>
				);
			},
		},
		{
			title: 'QUANTITY',
			dataIndex: 'quantity',
			key: 'QUANTITY',
			renderis: (record) => {
				return (
					<span style={{ display: 'flex', justifyContent: 'center' }}>
						{record.quantity}
					</span>
				);
			},
		},
		{
			title: 'PRIORITY',
			dataIndex: 'priority',
			key: 'PRIORITY',
			renderis: (record) => {
				if (record.priority === 'critical') {
					return (
						<span className="priorityIcons">
							<DoubleArrowIcon />
						</span>
					);
				} else if (record.priority === 'high') {
					return (
						<span className="priorityIcons">
							<ArrowIcon />
						</span>
					);
				} else if (record.priority === 'low') {
					return (
						<span className="priorityIcons">
							<DownIcon />
						</span>
					);
				} else {
					return (
						<span className="priorityIcons">
							<EqualIcon />
						</span>
					);
				}
			},
		},
		{
			title: 'LAST UPDATED',
			dataIndex: 'updatedAt',
			key: 'UPDATED',
			renderis: (record) => {
				const index = data.vendorsId?.indexOf(record.updatedBy);
				return (
					<span style={{ display: 'flex', flexDirection: 'column' }}>
						<span
							style={{
								color: '#B0B0B0',
								marginBottom: '6px',
								textTransform: 'capitalize',
							}}
						>
							{data.vendorUsers[index]?.name || ''}
						</span>
						<span style={{ color: 'E4E5E6', fontSize: '12px' }}>
							{moment.unix(record.updatedAt).local().startOf('seconds').fromNow()}
						</span>
					</span>
				);
			},
		},
	];

	const applyFilter = useCallback((filter, type) => {
		setFilters((prev) => {
			return {
				...prev,
				[`${type}Filter`]: filter,
			};
		});
	}, []);

	const handleclearSelection = useCallback((e, type) => {
		let value = [];
		if (type === 'workspace') {
			setFilters((prev) => {
				return {
					...prev,
					workspaceFilter: [],
					projectsFilter: '',
				};
			});
		}

		if (type === 'Assignedto' || type === 'projects') value = '';
		setFilters((prev) => {
			return {
				...prev,
				[`${type}Filter`]: value,
			};
		});
	}, []);

	const createParams = useCallback(() => {
		let filtersObj = {};
		for (const key in filters) {
			if (filters[key]?.length > 1 && typeof filters[key] != 'string') {
				filtersObj[key] = `${filters[key].join(',')}`;
			} else {
				filtersObj[key] = filters[key];
			}
		}
		setData((prev) => {
			return {
				...prev,
				search: filtersObj.search,
			};
		});
		setSearchParams((prev) => {
			return {
				...filtersObj,
			};
		});
	}, [filters]);

	const onChange = useCallback((page) => {
		setFilters((prev) => {
			return {
				...prev,
				page,
			};
		});
	}, []);

	const handleStatusFilter = useCallback((type) => {
		setFilters((prev) => {
			return {
				...prev,
				StatusFilter: type,
			};
		});
	}, []);

	const createDelay = useCallback(() => {
		setTimeout(() => {
			setLoad(false);
		}, 200);
	}, []);
	useEffect(() => {
		createDelay();
	}, [isPageLoading]);

	useEffect(() => {
		setTimeout(() => {
			setStatusLoad(false);
		}, 200);
	}, [isStateLoading]);

	const handleDebounceSearch = useCallback((e) => {
		setData((prev) => {
			return {
				...prev,
				search: e.target.value,
				page: 1,
			};
		});
		if (timeout.current) {
			clearTimeout(timeout.current);
		}

		timeout.current = setTimeout(() => {
			setFilters((prev) => {
				return {
					...prev,
					search: e.target.value,
					page: 1,
				};
			});
		}, 800);
	}, []);

	const handleKeyDown = useCallback((e) => {
		if (e.key === 'Enter') {
			setFilters((prev) => {
				return {
					...prev,
					search: e.target.value,
				};
			});
		}
	}, []);

	return (
		<div className="layout-wrapper">
			<div className="container">
				{!deliverablesData || !associatedTenants ? (
					<LoadingBar />
				) : (
					<>
						<div className="searchContainer">
							<div className="shoots-header-filters-container">
								<Filter
									type={'workspace'}
									label={'Workspaces'}
									version="v2"
									filters={data.associatedTenantsName}
									activeFilter={filters.workspaceFilter}
									clearSelection={(e) => handleclearSelection(e, 'workspace')}
									isMultipleSelectable={true}
									filterType="workspace"
									applyFilter={applyFilter}
								/>

								<Filter
									type={'Assignedto'}
									label={'Assigned to'}
									version="v2"
									filters={data.vendorUsers}
									activeFilter={filters.AssignedtoFilter}
									clearSelection={(e) => handleclearSelection(e, 'Assignedto')}
									isMultipleSelectable={false}
									filterType="Assignedto"
									applyFilter={applyFilter}
								/>

								{filters.workspaceFilter.length && data.projects?.length ? (
									<Filter
										type={'projects'}
										label={'Projects'}
										version="v2"
										filters={data.projects}
										activeFilter={filters.projectsFilter}
										isMultipleSelectable={false}
										filterType="projects"
										applyFilter={applyFilter}
										clearSelection={(e) => handleclearSelection(e, 'projects')}
									/>
								) : (
									''
								)}
							</div>
							<div
								style={{
									display: 'flex',
									flexDirection: 'row',
									gap: '10px',
								}}
							>
								<div className="searchWrapper">
									<div className="search-inner-left">
										<span className="search-icon">
											<SearchIcon />
										</span>
										<input
											placeholder="Search Client"
											ref={timeout}
											onKeyDown={handleKeyDown}
											onChange={(e) => handleDebounceSearch(e)}
											value={data.search}
										/>
									</div>
									<div className="search-inner-right">
										<span className="search-dropdown-btn">
											<a className="search-type" href>
												Search
											</a>
										</span>
									</div>
								</div>

								<div
									className="create-shoot-btn"
									onClick={() => updateModalState('modalShow', true)}
								>
									+ Create deliverable
								</div>
							</div>
						</div>
						{isStateLoading || statusload ? (
							<LoadingBar />
						) : (
							<>
								<div
									className={'table shoots-table'}
									id={'scrollableDiv-shoots-vendors'}
									style={{
										marginTop: '1.5em',
									}}
								>
									<div className="projects-table-outer-container">
										<Space size={[8, 0]} wrap>
											<span onClick={() => handleStatusFilter('')}>
												<LabelCard
													data="ALL"
													info={data.all || 0}
													bgColor={
														filters.StatusFilter === '' ? '#6055EC' : ''
													}
												/>
											</span>
											<span onClick={() => handleStatusFilter('pending')}>
												<LabelCard
													data="Pending"
													info={
														data.statusFiltercount.todo +
															data.statusFiltercount.inProgress +
															data.statusFiltercount.inReview || 0
													}
													bgColor={
														filters.StatusFilter === 'pending'
															? '#6055EC'
															: ''
													}
												/>
											</span>
											<span onClick={() => handleStatusFilter('todo')}>
												<LabelCard
													data="To DO"
													info={data.statusFiltercount.todo || 0}
													checkbox={true}
													checkColor="#9F4DB7"
													bgColor={
														filters.StatusFilter === 'todo'
															? '#6055EC'
															: ''
													}
												/>
											</span>
											<span onClick={() => handleStatusFilter('inProgress')}>
												<LabelCard
													data="In Progress"
													info={data.statusFiltercount.inProgress || 0}
													checkbox={true}
													checkColor="#5383EC"
													bgColor={
														filters.StatusFilter === 'inProgress'
															? '#6055EC'
															: ''
													}
												/>
											</span>

											<span onClick={() => handleStatusFilter('inReview')}>
												<LabelCard
													data="In Review"
													info={data.statusFiltercount.inReview || 0}
													checkbox={true}
													checkColor="#8EE2C7"
													bgColor={
														filters.StatusFilter === 'inReview'
															? '#6055EC'
															: ''
													}
												/>
											</span>
											<spna onClick={() => handleStatusFilter('done')}>
												<LabelCard
													data="Done"
													info={data.statusFiltercount.done || 0}
													checkbox={true}
													checkColor="#479A5F"
													bgColor={
														filters.StatusFilter === 'done'
															? '#6055EC'
															: ''
													}
												/>
											</spna>
											<spna onClick={() => handleStatusFilter('onHold')}>
												<LabelCard
													data="On Hold"
													info={data.statusFiltercount.onHold || 0}
													checkbox={true}
													checkColor="rgb(255, 87, 51)"
													bgColor={
														filters.StatusFilter === 'onHold'
															? '#6055EC'
															: ''
													}
												/>
											</spna>
											<span onClick={() => handleStatusFilter('unassigned')}>
												<LabelCard
													data="Unassigned"
													info={data.unassigned || 0}
													bgColor={
														filters.StatusFilter === 'unassigned'
															? '#6055EC'
															: ''
													}
												/>
											</span>
											<span onClick={() => handleStatusFilter('unscheduled')}>
												<LabelCard
													data="Due date TBD"
													info={data.unscheduled || 0}
													bgColor={
														filters.StatusFilter === 'unscheduled'
															? '#6055EC'
															: ''
													}
												/>
											</span>
											<span onClick={() => handleStatusFilter('overdue')}>
												<LabelCard
													data="Overdue"
													info={data.overdue || 0}
													text="#CA5A4F"
													bgColor={
														filters.StatusFilter === 'overdue'
															? '#6055EC'
															: ''
													}
												/>
											</span>
										</Space>
									</div>
								</div>
								{isPageLoading || load ? (
									<LoadingBar />
								) : (
									<div
										className={'table shoots-table'}
										id={'scrollableDiv-shoots-vendors'}
										style={{
											marginTop: '1.5em',
											display: load ? 'none' : '',
										}}
									>
										<DeliverablesTable
											columns={columns}
											dataSource={data.dataSource}
											showNoDateData={
												filters.StatusFilter === 'unscheduled'
													? true
													: false
											}
											onClickView={sayChange}
											totalItems={data.totalDocs}
											pageSize={10}
											currentPage={+filters.page || 1}
											onChangePage={onChange}
										/>
										<div
											style={{
												display: 'flex',
												justifyContent: 'flex-end',
												marginBottom: '0',
											}}
										>
											<Pagination
												totalItems={data.totalDocs}
												pageSize={10}
												currentPage={+filters.page || 1}
												onChangePage={onChange}
											/>
										</div>
									</div>
								)}
							</>
						)}
					</>
				)}

				<DeliverablesCreateModal />
				{data.slider ? (
					<CreateDeliverSlider
						project={data.projectLabelValue}
						workspace={data.workspaceLabelValue}
						type="edit"
					/>
				) : (
					''
				)}
			</div>
		</div>
	);
};

export default Deliverables;
